// src/pages/locations/components/countryFlag.ts

/**
 * ISO 3166-1 alpha-2 → flag emoji (a regional indicator pair). Platforms
 * without flag glyphs render the two letters instead, which still reads fine.
 */
export function countryFlag(iso2: string): string {
  const code = String(iso2 ?? "").trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return "";

  return String.fromCodePoint(
    ...[...code].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65)
  );
}
